import { format } from "date-fns";
import moment from "moment-timezone";
import { LiveOnlineCourseModel } from "services/organizationPortalClient";
import { eventTimeFormat, standardDateFormat } from "utils/dateUtils";

type DateTimeCellProps = {
  value: LiveOnlineCourseModel;
};

export default function DateTimeCell({ value }: DateTimeCellProps) {
  if (!value.eventStartDate) {
    return null;
  }

  return (
    <>
      {format(value.eventStartDate, standardDateFormat)}
      <br />
      {format(value.eventStartDate, eventTimeFormat)}
      {" - "}
      {value.eventEndDate && format(value.eventEndDate, eventTimeFormat)}
      {" ("}
      {moment.tz(moment.tz.guess()).zoneAbbr()}
      {")"}
    </>
  );
}
